import { useNavigate } from 'react-router';
import styles from './TopBar.module.css';

export interface TopBarProps {
	useBackButton?: boolean;
}

export const TopBar = (props: TopBarProps) => {
	const navigate = useNavigate();

	return (
		<>
			<div className={styles.Logo}>
				{props.useBackButton ? (
					<button className={styles.BackButton} onClick={() => navigate('/')}>
						<span className={styles.materialSymbolsOutlined}>arrow_back</span>
					</button>
				) : (
					<></>
				)}

				<div className={styles.LogoDiv}>
					<h1 className={styles.LogoText}>Padureanu IT</h1>
				</div>
			</div>
		</>
	);
};
